import { Button, Flex, Space, Stack, Text, Title } from '@mantine/core';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { utils, writeFile } from 'xlsx';
import { useMutation } from '@tanstack/react-query';
import { listBadges } from '../../services/report-gamification';
import LabelDate from '../../components/fragments/LabelDate';
import DataTables from '../../components/elements/DataTables';
import LoadingIllustration from '../../components/fragments/IllustrationState/LoadingIllustration';
import Card from '../../components/elements/Card';

export default function BadgeTable() {
  const [proses, setProses] = useState(false);
  const [badges, setBadges] = useState([]);
  const [badgeId, setBadgeId] = useState(null);
  const renderDate = (item, key) => <LabelDate date={item[key]} />;

  const renderConvertExcel = () => {
    const filename = `List Badge - download at ${dayjs().toLocaleString()}`;

    const wb = utils.book_new();

    // Convert the JSON data to a worksheet
    const ws = utils.json_to_sheet(badges);

    // Add the worksheet to the workbook
    utils.book_append_sheet(wb, ws, 'Badge');

    // Write the workbook to a file
    // This will trigger a file download in the browser
    writeFile(wb, `${filename}.xlsx`);
  };

  const columnsBadge = [
    {
      heading: 'Badge Name',
      props: 'badgeName',
      id: 'badgeName',
      sortable: true
    },
    {
      heading: 'User Count',
      props: (item) => (
        <Text>
          {item.userCount} {item.userCount > 1 ? 'Users' : 'User'}
        </Text>
      ),
      id: 'userCount',
      sortable: true
    },
    {
      heading: 'Action',
      props: (item) => (
        <Space>
          <Button
            color="purple"
            radius="md"
            onClick={() => {
              setBadgeId(item.badgeID);
              handleBadge(item.badgeID);
            }}
          >
            View User
          </Button>
        </Space>
      )
    }
  ];

  const columnsBadgePicked = [
    {
      heading: 'Badge Name',
      props: 'badgeName',
      id: 'badgeName',
      sortable: true
    },
    {
      heading: 'Binusian Name',
      props: 'namaUser',
      id: 'namaUser',
      sortable: true
    },

    {
      heading: 'Timestamp',
      props: (item) => renderDate(item, 'timestamp'),
      id: 'timestamp',
      sortable: true
    }
  ];

  useEffect(() => {
    handleBadge(null);
  }, []);

  const handleBadge = (passBadgeID) => {
    setProses(true);
    const payload = {
      badgeID: passBadgeID
    };
    fetchCategory.mutate(payload);
  };

  const fetchCategory = useMutation({
    mutationFn: listBadges,
    onSuccess: (data) => {
      setBadges(data?.data?.data);
      setProses(false);
    },
    onError: (error: any) => {
      alert(error);
    }
  });
  return (
    <Card>
      <Flex
        style={{
          justifyContent: 'space-between'
        }}
      >
        <Stack mb={10} gap={'xs'}>
          <Title order={4}>Report Gamification - Badge</Title>
          <Text size="sm">
            You can select one of the badges listed below to breakdown who has
            earned the badge.
          </Text>
        </Stack>
        <Flex>
          <Button
            color="teal"
            radius="md"
            onClick={() => {
              renderConvertExcel();
            }}
          >
            Download
          </Button>

          {badgeId && (
            <Button
              color="gray"
              radius="md"
              ml={10}
              onClick={() => {
                setBadgeId(null);
                handleBadge(null);
              }}
            >
              Back
            </Button>
          )}
        </Flex>
      </Flex>
      {badges.length === 0 && proses ? (
        <LoadingIllustration />
      ) : (
        <DataTables
          columns={badgeId ? columnsBadgePicked : columnsBadge}
          loading={false}
          data={badges || []}
        />
      )}
    </Card>
  );
}
